import { Debt } from "../../models/Entities/CashFlow/Debt/Debt";
import { DebtIndicators } from "../../models/Entities/CashFlow/Debt/DebtIndicators";
import { CommonState } from "../common/state/commonState";


export interface CashFlowDebtState extends CommonState<Debt> {
    // updating all
    isUpdatingAll: boolean;
    isUpdatingAllSuccess: boolean|undefined;
    FailUpdatingAll: boolean;

    // AddRange
    isAddingFinishedSuccessfully: boolean | undefined;

     // money owed
     DebtsAsDebtor: Debt[];

     // money to receive
     DebtsAsCreditor: Debt[];

    // check if debt is paid
    isCheckingDebtPaid: boolean;
    successCheckingDebtPaid: boolean | undefined;
    failOnCheckingDebtPaid: boolean;
    debtIsPaid: boolean | undefined;
    checkedDebtId: number | undefined;

    // check debt status (POST — fires domain events)
    isCheckingDebtStatus: boolean;
    successCheckingDebtStatus: boolean | undefined;
    failOnCheckingDebtStatus: boolean;
    debtStatusResult: boolean | undefined;
    checkedDebtStatusId: number | undefined;

    // debt indicators
    isLoadingIndicators: boolean;
    successLoadingIndicators: boolean | undefined;
    failOnLoadingIndicators: boolean;
    debtIndicators: DebtIndicators | undefined;
}

export const CashFlowDebtUnloadState: any = {
    // loading all
    isLoadingAll: false,
    isLoadingAllSuccess: undefined,
    FailGettingAll: false,

    // updating all
    isUpdatingAll: false,
    isUpdatingAllSuccess: undefined,
    FailUpdatingAll: false,

    // loading one
    isLoadingOne: false,
    isLoadingOneSuccess: undefined,
    FailGettingOne: false,

    // updating
    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,
    
    // adding
    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    // deleting
    isDeletingOne: false,
    isDeletingOneSuccess: undefined,
    FailDeletingOne: false, 

    // AddRange
    isAddingFinishedSuccessfully: undefined,

    // money owed
    DebtsAsDebtor: [],

    // money to receive
    DebtsAsCreditor: [],

    // check if debt is paid
    isCheckingDebtPaid: false,
    successCheckingDebtPaid: undefined,
    failOnCheckingDebtPaid: false,
    debtIsPaid: undefined,
    checkedDebtId: undefined,

    // check debt status (POST — fires domain events)
    isCheckingDebtStatus: false,
    successCheckingDebtStatus: undefined,
    failOnCheckingDebtStatus: false,
    debtStatusResult: undefined,
    checkedDebtStatusId: undefined,

    // debt indicators
    isLoadingIndicators: false,
    successLoadingIndicators: undefined,
    failOnLoadingIndicators: false,
    debtIndicators: undefined
};